import type { IAuthState } from "./types";

export const getUser = (state: { auth: IAuthState }) => state.auth.user;
export const selectIsAuthenticated = (state: { auth: IAuthState }) =>
  state.auth.isAuthenticated;
export const selectUserRole = (state: { auth: IAuthState }) =>
  state.auth.user?.role;
export const selectIsAuthenticating = (state: { auth: IAuthState }) =>
  state.auth.isAuthenticating;

export const selectHasPaid = (state: { auth: IAuthState }) =>
  Boolean(state.auth.user?.isPaid);
export const getIsAuthenticating = (auth: IAuthState) => auth.isAuthenticating;
